import App from './containers/App';

export { App };
